













import Vue from "vue";
import Shared from "@/shared";
import { Case } from "@/types/case/case";
import { Controllers } from "@infoland/iprova-api";
import Utils from "@/utils";

export default Vue.extend({
    name: "CaseInfo",
    props: {
        case: Object as () => Case
    },
    data: () => ({
        caseIdLength: 0
    }),
    computed: {
        caseNumber(): String {
            return Utils.padNumbers(this.case.case_id, this.caseIdLength);
        }
    },
    methods: {
        openCase() {
            const path = `${Shared.iProvaUrl}/iTask/Tasks/SummaryFrame.aspx?OpenedTab=Overview&TaskID=${this.case.case_id}`;
            window.open(path);
        },
        seeReporterForm() {
            const path = `${Shared.iProvaUrl}/iTask/Tasks/Task_ReadReporterForm.aspx?TaskID=${this.case.case_id}`;
            window.open(path);
        }
    },
    async created() {
        this.caseIdLength = await Controllers.GenericController.getAsync<number>("settings/case_id_length");
    }
});
